import {ref} from 'vue';

export default {
    install: (app, options) => {
        const categories = ref([]);

        const loadCategories = (urlParameters = '') => {

            window.lazy_axios.get(`/categories/?all=true&${urlParameters}`)
                .then((response) => {
                    if (response.data.categories) {
                        categories.value = response.data.categories;
                    }
                });
        };

        app.provide('categories', categories);
        app.provide('loadCategories', loadCategories);
    },
}
